import React from 'react';

export default function EducationCard2(props) {
	// console.log('EducationCard', props);
	return (
		<section className="EducationCard md:mx-4 min-w-80 my-4 p-7 rounded-md shadow-lg border">
			<img
				src="https://matt-hoelzel.s3.us-west-1.amazonaws.com/northwestern_logo.png"
				className="float-left mr-4 inline-block clear"
				alt="northwestern-university-logo"
			/>
			<h2 className="text-sm md:text-lg  text-blue-500 hover:underline">
				<strong>
					<a
						href="https://sps.northwestern.edu/post-baccalaureate/advanced-accounting/"
						target="_blank"
						className="flex content-start"
					>
						Northwestern University
					</a>
				</strong>
			</h2>
			<h3 className="text-md lg:text-lg">
				Post-Baccalaureate Certificate, Advanced Accounting
			</h3>
			<ul className="list-disc ml-4 md:ml-6 mt-2 mb-5 font-thin text-md lg:text-base clear-left pt-3">
				<li>Successfully completed four upper-division accounting courses</li>
				<li>4.0 GPA</li>
			</ul>
		</section>
	);
}
